<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <div class="ts-border ts-rounded ts-p-3">
              <label>{{ $t('returnToVendor.stockInNumber') }}</label>
              <SearchBox
                v-model="search"
                :waiting="waiting"
                @onEnter="fetchStockIn"
              />
              <div class="ts-h-64 max-h ts-mt-3 ts-px-3">
                <table class="ts-w-full">
                  <thead>
                    <tr>
                      <th class="ts-uppercase ts-bg-gray-200 ts-px-2 ts-py-1"></th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-px-2 ts-py-1" >{{ $t('returnToVendor.productGroup') }}</th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-px-2 ts-py-1" >{{ $t('returnToVendor.productName') }}</th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-px-2 ts-py-1" >{{ $t('returnToVendor.productType') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(product, index) in productLists"
                      :key="index"
                    >
                      <td class="ts-px-2 ts-py-1">
                        <input type="checkbox"
                          :value="product"
                          v-model="chosenProduct"
                        >
                      </td>
                      <td class="ts-px-2 ts-py-1"> {{  product.pro_group_name_en }} </td>
                      <td class="ts-px-2 ts-py-1"> {{  product.product_name_en }} </td>
                      <td class="ts-px-2 ts-py-1"> {{  product.product_type_en }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-space-x-3 ts-justify-end">
            <ts-button @click.prevent="$emit('close')">{{
              $t('close')
            }}</ts-button>
            <ts-button color="primary" @click.prevent="addProduct">{{
              $t('add')
            }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SearchBox from './search-box.vue'
export default {
  name: 'manualAdd',
  props: ['value'],
  components: {
    SearchBox,
  },
  data() {
    return {
      waiting: false,
      productResources: [],
      chosenProduct: [],
      search: {
        search_value: '',
      },
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    productLists() {
      return this.productResources.filter((p) =>
        !_.includes(
          this.model.product_detail
            .filter(
              (d) => d.stock_in_id == this.productResources[0].stock_in_id
            )
            .map((el) => el.product_id),
          p.product_id
        )
      )
    },
  },
  methods: {
    ...mapActions('stock/returnToVendor', ['getStockInByNumber']),
    fetchStockIn() {
      this.waiting = true
      this.getStockInByNumber(this.search)
        .then((response) => {
          this.productResources = response.data
        })
        .finally(() => {
          this.waiting = false
        })
    },
    addProduct() {
      this.chosenProduct.forEach((el) => {
        let existing = this.model.product_detail.filter(
          (p) =>
            p.stock_in_id == el.stock_in_id && p.product_id == el.product_id
        )
        if (!existing.length > 0) {
          this.model.product_detail.push({
            product_id: el.product_id,
            product_name_en: el.product_name_en,
            uom_id: el.uom_id,
            uom_name_en: el.uom_name_en,
            quantity: 1,
            cost: el.cost,
            has_serial: el.has_serial,
            return_status_id: 1,
            stock_in_id: el.stock_in_id,
            stock_in_number: el.stock_in_number,
            pro_group_name_en: el.pro_group_name_en,
						product_type_en: el.product_type_en,
            remarks: '',
            serials: [],
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.w-fit {
  width: fit-content;
}
	.max-h {
		max-height: 400px;
		overflow: scroll;
	}
</style>
